import ParentCareerAPI from '@/apis/business/parentCareerAPI'
import CrudBase from '@/stores/crudBase.js'

const crudBase = new CrudBase('ParentCareer', ParentCareerAPI)
export default {
  namespaced: true,
  state: {
    ...crudBase.state,
    careers: [], // Danh sách nghề nghiệp
  },
  mutations: {
    ...crudBase.mutations,
    setListCareers (state, data) {
      state.careers = data
    },
  },
  getters: {
    ...crudBase.getters,
  },
  actions: {
    ...crudBase.actions,
  },
}
